// version-checker.js
export function setupVersionChecker(checkIntervalMinutes = 5) {
  const currentVersion = process.env.APP_VERSION;
  console.log('App versão atual:', currentVersion);
  
  if (process.env.NODE_ENV === 'production') {
    // Função para verificar atualizações
    const checkForUpdates = () => {
      console.log('Verificando atualizações...');
      
      // Adiciona um timestamp para evitar cache
      fetch(`${window.location.origin}/version.json?t=${new Date().getTime()}`)
        .then(response => response.json())
        .then(data => {
          console.log('Versão do servidor:', data.version);
          console.log('Versão atual:', currentVersion);
          
          if (data.version !== currentVersion) {
            console.log('Nova versão detectada! Forçando atualização...');
            
            // Exibir mensagem rápida (opcional)
            const notification = document.createElement('div');
            notification.style.position = 'fixed';
            notification.style.top = '0';
            notification.style.left = '0';
            notification.style.width = '100%';
            notification.style.backgroundColor = '#4CAF50';
            notification.style.color = 'white';
            notification.style.padding = '10px';
            notification.style.textAlign = 'center';
            notification.style.zIndex = '9999';
            notification.innerHTML = `Nova versão disponível (v${data.version}). Atualizando...`;
            
            document.body.appendChild(notification);
            
            // Forçar recarga da página após um breve atraso (para que o usuário possa ver a mensagem)
            setTimeout(() => {
              window.location.reload(true);
            }, 1500); // 1.5 segundos de atraso
          }
        })
        .catch(error => {
          console.error('Erro ao verificar atualizações:', error);
        });
    };
    
    // Verificar imediatamente e depois a cada X minutos
    checkForUpdates();
    setInterval(checkForUpdates, checkIntervalMinutes * 60 * 1000);
  }
}